/**
 * @format
 */
 export const SET_JOBS = 'set_jobs';
 export const TOGGLE_JOB_LIST_LOADING = 'toggle_job_list_loading';
 export const CHANGE_JOB_CURRENT_PAGE = 'change_job_current_page';
 export const ADD_JOB = 'add_job';

 